import { RouterView } from "vue-router";

export const BindHmdAccountRouting = {
  path: "/bind-hmd-account",
  name: "bind-hmd-account",
  component: RouterView,
  redirect: "/bind-hmd-account/index",
  meta: { title: "绑定河姆渡账号" },
  children: [
    {
      path: "/bind-hmd-account/index",
      name: "bind-hmd-account-index",
      meta: { title: "绑定河姆渡账号" },
      component: () => import(/* webpackChunkName: "bind-hmd-account-index" */ "@/views/bind-hmd-account/index.vue"),
    },
  ],
};